<template>
  <keep-alive>
    <div class="container-fluid table-vm-clientes" id="mlc">
      <div class="d-flex">
        <!-- BOTÓN DESCARGAR EXCEL -->
        <DescargarExcelAdmin :registros="copia" :cargando="cargando" />
        <!-- BOTÓN IMPORTAR MATRIZ -->
        <ImportarMatriz :cargando="cargando" />
      </div>
      <!-- LISTA DE MATRICES DE PELIGROS -->
      <MatrizPeligros @registros="obtenerMatrices" @cargando="obtenerCargando" />
    </div>
  </keep-alive>
</template>

<script>
import { db } from "@/firebase";
import MatrizPeligros from "../../components/MatrizPeligros/MatrizPeligros.vue";
import DescargarExcelAdmin from "../../components/MatrizPeligros/Acciones/DescargarExcelAdmin.vue";
import ImportarMatriz from "../../components/MatrizPeligros/Acciones/ImportarMatriz.vue";
export default {
  name: "mlc",

  components: {
    MatrizPeligros,
    DescargarExcelAdmin,
    ImportarMatriz
  },

  data() {
    return {
      copia: [],
      cargando: false,
    };
  },

  mounted() {
    $(".modal").modal("hide");
  },

  created() {
    if (!this.$store.state.email) {
      this.$router.replace("/");
      this.conteoPeligrosEmpresa();
      return;
    }
  },

  methods: {
    obtenerMatrices(data) {
      this.copia = JSON.parse(JSON.stringify(data));
    },

    obtenerCargando(data) {
      this.cargando = JSON.parse(JSON.stringify(data));
    },

    async conteoPeligrosEmpresa() {
      console.log('sera que entro?');
      let empresa = [];
      db.collection("cliente_empresa")
        .where("em_baja", "==", true)
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            empresa.push({
              id: doc.id,
              nombre: doc.data().em_trabajo,
            });
          });
          this.conteoPeligros(empresa);
        })
        .catch((error) => {
          console.log("Error getting documents: ", error);
        });
    },

    async conteoPeligros(empresas) {
      for (const item of empresas) {
        let conteito = [];
        db.collection("matriz_riesgo")
          .where("em_id_cliente", "==", item.id)
          .get()
          .then((querySnapshot) => {
            querySnapshot.forEach((doc) => {
              conteito.push(doc.id);
            });
            // console.log('datos import', item.nombre, conteito.length);
          })
          .catch((error) => {
            console.log("Error getting documents: ", error);
          });
      }
    },
  },
};
</script>